import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableRow,
  TableCell,
  MenuItem,
  TextField,
  Box,
  Button,
  IconButton,
  Stack,
} from "@mui/material";
import Buttons from "../../../components/Controls/Buttons/Button";
import BackButtons from "../../../components/Controls/Buttons/BackArrowButton";
import Label from "../../../components/Label/Label";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { InputAdornment } from "@mui/material";
import moment from "moment";
import { invalidIds } from "../../../utility";

const DefinitionPopup = ({
  open,
  onClose,
  formData,
  errors,
  onChange,
  handleSubmit,
  fieldType,
  setFieldType,
  sepcificaitonFormUpdate,
  viewData,
  handleAcceptanceValueChange,
  handleDeleteAcceptanceValue,
  handleAddAcceptanceValue,
  handleBlockChange,
  handleDeleteBlock,
  handleAddBlock,
  openData,
  parameter,
  viewPrimaryData,
  handleDelete,
  handleSaveAsDraft,
  limitOperation,
  addTargetData,
}) => {
  const [isEdit, setIsEdit] = React.useState(false);
  const [isAdd, setIsAdd] = React.useState(false);
  const specNames = [
    "IPL-Alert",
    "IPL-Action",
    "IPL-Accept",
    "IPM",
    "Spec-Release",
    "Spec-Stability",
    "AQL",
    "Internal - Release",
    "IPC",
  ];
  const handleClose = () => {
    setIsEdit(false);
    onClose();
  };

  React.useEffect(() => {
    setIsEdit(false);
  }, [viewData]);

  const formatValues = (
    lowerValue,
    upperValue,
    lowerLabel,
    upperLabel,
    bothLabel
  ) => {
    if (lowerValue || upperValue) {
      return `${bothLabel}: (${lowerValue ?? ''}${lowerValue != null && upperValue != null ? ', ' : ''}${upperValue ?? ''})`;
    }
    // if (lowerValue) {
    //   return `${lowerLabel}: (${lowerValue})`;
    // }
    // if (upperValue) {
    //   return `${upperLabel}: (${upperValue})`;
    // }
    return "";
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      hideBackdrop
      disableEnforceFocus
      keepMounted={false}
      PaperProps={{
        sx: {
          position: "fixed",
          bottom: 0,
          right: 2,
          m: 0,
          width: isEdit ? 500 : 550,
          maxHeight: "calc(100% - 142px)",
          height: "100%",
          boxShadow: "none",
          elevation: 0,
          border: "1px solid #ccc",
          p: 1,
          paddingBottom: 0,
          transition: "width 0.3s ease",
        },
      }}
    >
      {" "}
      {isEdit ? (
        <>
          {" "}
          <>
            <DialogTitle className="dialog-title" sx={{ mb: 2 }}>
              <Label
                text={isAdd ? "Add Limit" : `Edit ${fieldType} Limit`}
                color="#fff"
                fontSize="14px"
                fontWeight="500"
              ></Label>

              <BackButtons onClick={() => setIsEdit(false)} />
            </DialogTitle>
            <DialogContent sx={{ padding: 0.5 }}>
              {fieldType === "control" && (
                <>
                  <Box
                    sx={{
                      // width: 300,
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      paddingTop: 1,
                    }}
                  >
                    <TextField
                      select
                      variant="outlined"
                      label="Parameter Name"
                      name="parameter_id"
                      fullWidth
                      value={formData?.parameter_id}
                      onChange={onChange}
                      error={!!errors?.parameter_id}
                      helperText={errors?.parameter_id}
                      disabled
                      size="small"
                      required
                      InputLabelProps={{
                        style: {
                          fontSize: "14px",
                          backgroundColor: "#fff",
                          padding: "0 4px",
                        },
                      }}
                    >
                      <MenuItem value="">
                        <>Unit of Measurement</>
                      </MenuItem>
                      {parameter?.parameter_names?.map((item) => (
                        <MenuItem value={item.parameter_id}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </TextField>
                    <Box display={"flex"} gap={1} sx={{ py: 1 }}>
                      <TextField
                        label="Valid Form"
                        variant="outlined"
                        name="validFrom"
                        fullWidth
                        type="date"
                        size="small"
                        value={formData?.validFrom}
                        onChange={onChange}
                        InputLabelProps={{ shrink: true }}
                        error={!!errors?.validFrom}
                        helperText={errors?.validFrom}
                        required
                      />
                      <TextField
                        label="Valid Through"
                        variant="outlined"
                        name="validThrough"
                        fullWidth
                        type="date"
                        size="small"
                        value={formData?.validThrough}
                        onChange={onChange}
                        InputLabelProps={{ shrink: true }}
                        error={!!errors?.validThrough}
                        helperText={errors?.validThrough}
                      />
                    </Box>
                    <TextField
                      fullWidth
                      label="Box-Cox transformation (λ) value"
                      name="boxCoxLambdaValue"
                      variant="outlined"
                      size="small"
                      value={formData?.boxCoxLambdaValue}
                      onChange={onChange}
                      error={!!errors?.boxCoxLambdaValue}
                      helperText={errors?.boxCoxLambdaValue}
                    />
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <TextField
                        fullWidth
                        label="LCL"
                        name="lcl"
                        variant="outlined"
                        size="small"
                        required
                        value={formData?.lcl}
                        onChange={onChange}
                        error={!!errors?.lcl}
                        helperText={errors?.lcl}
                      />
                      <TextField
                        fullWidth
                        label="UCL"
                        name="ucl"
                        required
                        variant="outlined"
                        size="small"
                        value={formData?.ucl}
                        onChange={onChange}
                        error={!!errors?.ucl}
                        helperText={errors?.ucl}
                      />
                    </Box>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <TextField
                        fullWidth
                        label="LWL"
                        name="lwl"
                        variant="outlined"
                        size="small"
                        value={formData?.lwl}
                        onChange={onChange}
                        error={!!errors?.lwl}
                        helperText={errors?.lwl}
                      />
                      <TextField
                        fullWidth
                        label="UWL"
                        name="uwl"
                        variant="outlined"
                        size="small"
                        value={formData?.uwl}
                        onChange={onChange}
                        error={!!errors?.uwl}
                        helperText={errors?.uwl}
                      />
                    </Box>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <TextField
                        fullWidth
                        label="LIL"
                        name="lil"
                        variant="outlined"
                        size="small"
                        value={formData?.lil}
                        onChange={onChange}
                        error={!!errors?.lil}
                        helperText={errors?.lil}
                      />
                      <TextField
                        fullWidth
                        label="UIL"
                        name="uil"
                        variant="outlined"
                        size="small"
                        value={formData?.uil}
                        onChange={onChange}
                        error={!!errors?.uil}
                        helperText={errors?.uil}
                      />
                    </Box>

                    <TextField
                      fullWidth
                      label="Mean"
                      name="mean"
                      variant="outlined"
                      size="small"
                      value={formData?.mean}
                      onChange={onChange}
                      error={!!errors?.mean}
                      helperText={errors?.mean}
                    />

                    <Box sx={{ display: "flex", gap: 1 }}>
                      <TextField
                        fullWidth
                        label="ST Std dev"
                        name="ststddev"
                        variant="outlined"
                        size="small"
                        value={formData?.stsddev}
                        onChange={onChange}
                        error={!!errors?.stsddev}
                        helperText={errors?.stsddev}
                      />
                      <TextField
                        fullWidth
                        label="LT Std dev"
                        name="ltstddev"
                        variant="outlined"
                        size="small"
                        value={formData?.ltstddev}
                        onChange={onChange}
                        error={!!errors?.ltstddev}
                        helperText={errors?.ltstddev}
                      />
                    </Box>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <TextField
                        fullWidth
                        label="Cp"
                        name="cp"
                        variant="outlined"
                        size="small"
                        value={formData?.cp}
                        onChange={onChange}
                        error={!!errors?.cp}
                        helperText={errors?.cp}
                      />
                      <TextField
                        fullWidth
                        label="Cpl"
                        name="cpl"
                        variant="outlined"
                        size="small"
                        value={formData?.cpl}
                        onChange={onChange}
                        error={!!errors?.cpl}
                        helperText={errors?.cpl}
                      />
                    </Box>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <TextField
                        fullWidth
                        label="Cpu"
                        name="cpu"
                        variant="outlined"
                        size="small"
                        value={formData?.cpu}
                        onChange={onChange}
                        error={!!errors?.cpu}
                        helperText={errors?.cpu}
                      />
                      <TextField
                        fullWidth
                        label="Cpk"
                        name="cpk"
                        variant="outlined"
                        size="small"
                        value={formData?.cpk}
                        onChange={onChange}
                        error={!!errors?.cpk}
                        helperText={errors?.cpk}
                      />
                    </Box>

                    <Box sx={{ display: "flex", gap: 1 }}>
                      <TextField
                        fullWidth
                        label="Pp"
                        name="pp"
                        variant="outlined"
                        size="small"
                        value={formData?.pp}
                        onChange={onChange}
                        error={!!errors?.pp}
                        helperText={errors?.pp}
                      />
                      <TextField
                        fullWidth
                        label="Ppl"
                        name="ppl"
                        variant="outlined"
                        size="small"
                        value={formData?.ppl}
                        onChange={onChange}
                        error={!!errors?.ppl}
                        helperText={errors?.ppl}
                      />
                    </Box>

                    <Box sx={{ display: "flex", gap: 1 }}>
                      <TextField
                        fullWidth
                        label="Ppu"
                        name="ppu"
                        variant="outlined"
                        size="small"
                        value={formData?.ppu}
                        onChange={onChange}
                        error={!!errors?.ppu}
                        helperText={errors?.ppu}
                      />
                      <TextField
                        fullWidth
                        label="Ppk"
                        name="ppk"
                        variant="outlined"
                        size="small"
                        value={formData?.ppk}
                        onChange={onChange}
                        error={!!errors?.ppk}
                        helperText={errors?.ppk}
                      />
                    </Box>
                    <TextField
                      fullWidth
                      label="Change Reason"
                      name="changeReason"
                      variant="outlined"
                      size="small"
                      value={formData?.changeReason}
                      onChange={onChange}
                      error={!!errors?.changeReason}
                      helperText={errors?.changeReason}
                      required
                    />
                  </Box>
                </>
              )}
              {fieldType === "specification" && (
                <>
                  <Box
                    sx={{
                      // width: 300,
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      paddingTop: 1,
                    }}
                  >
                    <TextField
                      select
                      variant="outlined"
                      label="Parameter Name"
                      name="parameter_id"
                      fullWidth
                      disabled
                      value={sepcificaitonFormUpdate?.parameter_id}
                      onChange={onChange}
                      error={!!errors?.parameter_id}
                      helperText={errors?.parameter_id}
                      size="small"
                      required
                      InputLabelProps={{
                        style: {
                          fontSize: "14px",
                          backgroundColor: "#fff",
                          padding: "0 4px",
                        },
                      }}
                    >
                      <MenuItem value="">
                        <>Unit of Measurement</>
                      </MenuItem>
                      {parameter?.parameter_names?.map((item) => (
                        <MenuItem value={item.parameter_id}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </TextField>
                    <Box display={"flex"} gap={1} sx={{ py: 1 }}>
                      <TextField
                        label="Valid Form"
                        variant="outlined"
                        name="validFrom"
                        fullWidth
                        type="date"
                        size="small"
                        value={sepcificaitonFormUpdate?.validFrom}
                        onChange={onChange}
                        InputLabelProps={{ shrink: true }}
                        error={!!errors?.validFrom}
                        helperText={errors?.validFrom}
                        required
                      />
                      <TextField
                        label="Valid Through"
                        variant="outlined"
                        name="validThrough"
                        fullWidth
                        type="date"
                        size="small"
                        value={sepcificaitonFormUpdate?.validThrough}
                        onChange={onChange}
                        InputLabelProps={{ shrink: true }}
                        error={!!errors?.validThrough}
                        helperText={errors?.validThrough}
                      />
                    </Box>

                    <Box
                      sx={{
                        mt: 1,
                        border: 1,
                        p: 1,
                        borderColor: "#ccc",
                        borderRadius: 2,
                      }}
                    >
                      <Label
                        variant="subtitle1"
                        gutterBottom
                        text={"Acceptance Values"}
                      ></Label>

                      <Stack spacing={2}>
                        {sepcificaitonFormUpdate?.acceptanceValue?.map(
                          (value, index) => (
                            <Box
                              key={index}
                              display="flex"
                              alignItems="center"
                              gap={1}
                            >
                              <TextField
                                fullWidth
                                label={`Value ${index + 1}`}
                                value={value}
                                size="small"
                                required
                                onChange={(e) =>
                                  handleAcceptanceValueChange(
                                    "update",
                                    index,
                                    e.target.value
                                  )
                                }
                              />
                              <IconButton
                                onClick={() =>
                                  handleDeleteAcceptanceValue("update", index)
                                }
                                color="error"
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          )
                        )}
                      </Stack>

                      <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={() => handleAddAcceptanceValue("update")}
                        sx={{ mt: 2 }}
                      >
                        Add Acceptance Value
                      </Button>
                    </Box>
                    {/* <TextField
                      fullWidth
                      label="Box-Cox transformation (λ) value"
                      name="boxCoxLambdaValue"
                      variant="outlined"
                      size="small"
                      value={sepcificaitonFormUpdate?.boxCoxLambdaValue}
                      onChange={onChange}
                      error={!!errors?.boxCoxLambdaValue}
                      helperText={errors?.boxCoxLambdaValue}
                    /> */}
                    {/* <TextField
                          select
                          label="Specification limit name "
                          name="specificationLimit"
                          variant="outlined"
                          fullWidth
                          size="small"
                          value={sepcificaitonFormUpdate?.specificationLimit}
                          onChange={onChange}
                          error={!!errors?.specificationLimit}
                          helperText={errors?.specificationLimit}
                          InputLabelProps={{
                            style: {
                              top: "-6px",
                              fontSize: "14px",
                              backgroundColor: "#fff",
                              padding: "0 4px",
                            },
                          }}
                        >
                          <MenuItem value="">Select</MenuItem>
                          <MenuItem value="source1">Source 1</MenuItem>
                          <MenuItem value="source2">Source 2</MenuItem>
                        </TextField>
                        <Box display="flex" alignItems="center" gap={2}>
                          <TextField
                            select
                            label="Lower limit Type "
                            name="lowerLimitType"
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={sepcificaitonFormUpdate?.lowerLimitType}
                            onChange={onChange}
                            error={!!errors?.lowerLimitType}
                            helperText={errors?.lowerLimitType}
                            InputLabelProps={{
                              style: {
                                top: "-6px",
                                fontSize: "14px",
                                backgroundColor: "#fff",
                                padding: "0 4px",
                              },
                            }}
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="source1">{">="}</MenuItem>
                            <MenuItem value="source2">{">"}</MenuItem>
                          </TextField>

                          <TextField
                            label="Value"
                            fullWidth
                            type="number"
                            name="lowerLimitValue"
                            size="small"
                            value={sepcificaitonFormUpdate?.lowerLimitValue}
                            onChange={onChange}
                          />
                        </Box>
                        <Box display="flex" alignItems="center" gap={2}>
                          <TextField
                            select
                            label="Upper limit Type "
                            name="upperLimitType"
                            variant="outlined"
                            size="small"
                            value={sepcificaitonFormUpdate?.upperLimitType}
                            onChange={onChange}
                            error={!!errors?.upperLimitType}
                            helperText={errors?.upperLimitType}
                            InputLabelProps={{
                              style: {
                                top: "-6px",
                                fontSize: "14px",
                                backgroundColor: "#fff",
                                padding: "0 4px",
                              },
                            }}
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="source1">{"<="}</MenuItem>
                            <MenuItem value="source2">{"<"}</MenuItem>
                          </TextField>

                          <TextField
                            fullWidth
                            label="Value"
                            type="number"
                            name="lowerLimitValue"
                            size="small"
                            value={sepcificaitonFormUpdate?.upperLimitValue}
                            onChange={onChange}
                          />
                        </Box> */}
                    <TextField
                      fullWidth
                      label="Acceptance Criteria"
                      name="acceptanceCriteria"
                      variant="outlined"
                      size="small"
                      value={sepcificaitonFormUpdate?.acceptanceCriteria}
                      onChange={onChange}
                      error={!!errors?.acceptanceCriteria}
                      helperText={errors?.acceptanceCriteria}
                    />
                    <TextField
                      fullWidth
                      label="Method"
                      name="method"
                      variant="outlined"
                      size="small"
                      value={sepcificaitonFormUpdate?.method}
                      onChange={onChange}
                      error={!!errors?.method}
                      helperText={errors?.method}
                    />
                    <TextField
                      label="Process Target"
                      name="processTarget"
                      variant="outlined"
                      fullWidth
                      // required
                      size="small"
                      value={sepcificaitonFormUpdate?.processTarget}
                      onChange={onChange}
                      error={!!errors?.processTarget}
                      helperText={errors?.processTarget}
                    />
                    {/* <TextField
                      fullWidth
                      label="Box-Cox transformation (λ) value"
                      name="boxCoxLambdaValue"
                      variant="outlined"
                      size="small"
                      value={sepcificaitonFormUpdate?.boxCoxLambdaValue}
                      onChange={onChange}
                      error={!!errors?.boxCoxLambdaValue}
                      helperText={errors?.boxCoxLambdaValue}
                      required
                    /> */}
                    <TextField
                      fullWidth
                      label="Change Reason"
                      name="changeReason"
                      variant="outlined"
                      size="small"
                      value={sepcificaitonFormUpdate?.changeReason}
                      onChange={onChange}
                      error={!!errors?.changeReason}
                      helperText={errors?.changeReason}
                      required
                    />
                    {!invalidIds.includes(sepcificaitonFormUpdate?.parameter_id) && (
                      <>
                        <TextField
                          fullWidth
                          select
                          label="Specification limit name"
                          size="small"
                          name="spec_name"
                          value={sepcificaitonFormUpdate?.spec_name}
                          onChange={onChange}
                          error={!!errors?.spec_name}
                          helperText={errors?.spec_name}
                        >
                          {specNames?.map((item) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </TextField>
                        <Box>
                          {sepcificaitonFormUpdate?.specificationLimitBlock?.map(
                            (block, index) => (
                              <Box
                                key={index}
                                sx={{
                                  // border: "1px solid #ccc",
                                  // borderRadius: 2,
                                  // p: 2,
                                  pb: 2,
                                  mb: 1,
                                  position: "relative",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 1,
                                }}
                              >
                                <Box display="flex" gap={1}>
                                  <TextField
                                    select
                                    size="small"
                                    sx={{ minWidth: "80px" }}
                                    name="lowerLimitType"
                                    value={block.lowerLimitType}
                                    error={
                                      !!errors?.specificationLimitBlock?.[index]
                                        ?.lowerLimitType
                                    }
                                    helperText={
                                      errors?.specificationLimitBlock?.[index]
                                        ?.lowerLimitType
                                    }
                                    onChange={(e) =>
                                      handleBlockChange(
                                        "add",
                                        index,
                                        "lowerLimitType",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <MenuItem value={null}>Select</MenuItem>
                                    {[">=", ">"].map((type) => (
                                      <MenuItem key={type} value={type}>
                                        {type}
                                      </MenuItem>
                                    ))}
                                  </TextField>

                                  <TextField
                                    fullWidth
                                    label="Lower Limit Value"
                                    type="number"
                                    size="small"
                                    name="lowerLimitValue"
                                    value={block.lowerLimitValue}
                                    error={
                                      !!errors?.specificationLimitBlock?.[index]
                                        ?.lowerLimitValue
                                    }
                                    helperText={
                                      errors?.specificationLimitBlock?.[index]
                                        ?.lowerLimitValue
                                    }
                                    onChange={(e) =>
                                      handleBlockChange(
                                        "add",
                                        index,
                                        "lowerLimitValue",
                                        e.target.value
                                      )
                                    }
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          {block.lowerLimitType}
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                </Box>
                                {/* Upper limit */}
                                <Box display="flex" gap={1}>
                                  <TextField
                                    select
                                    size="small"
                                    sx={{ minWidth: "80px" }}
                                    name="upperLimitType"
                                    value={block.upperLimitType}
                                    error={
                                      !!errors?.specificationLimitBlock?.[index]
                                        ?.upperLimitType
                                    }
                                    helperText={
                                      errors?.specificationLimitBlock?.[index]
                                        ?.upperLimitType
                                    }
                                    onChange={(e) =>
                                      handleBlockChange(
                                        "add",
                                        index,
                                        "upperLimitType",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <MenuItem value={null}>Select</MenuItem>
                                    {["<", "<="].map((type) => (
                                      <MenuItem key={type} value={type}>
                                        {type}
                                      </MenuItem>
                                    ))}
                                  </TextField>

                                  <TextField
                                    fullWidth
                                    label="Upper Limit Value"
                                    type="number"
                                    size="small"
                                    name="upperLimitValue"
                                    value={block.upperLimitValue}
                                    onChange={(e) =>
                                      handleBlockChange(
                                        "add",
                                        index,
                                        "upperLimitValue",
                                        e.target.value
                                      )
                                    }
                                    error={
                                      !!errors?.specificationLimitBlock?.[index]
                                        ?.upperLimitValue
                                    }
                                    helperText={
                                      errors?.specificationLimitBlock?.[index]
                                        ?.upperLimitValue
                                    }
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          {block.upperLimitType}
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                </Box>
                                {sepcificaitonFormUpdate?.specificationLimitBlock
                                  ?.length > 1 && (
                                    <IconButton
                                      onClick={() => handleDeleteBlock(index)}
                                      sx={{
                                        position: "absolute",
                                        bottom: 0,
                                        right: 8,
                                      }}
                                      color="error"
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  )}
                              </Box>
                            )
                          )}
                          {/* <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={() => handleAddBlock("add")}
                      >
                        Add Specification Block
                      </Button> */}
                        </Box>
                      </>
                    )}
                  </Box>
                </>
              )}
              {fieldType === "target" && (
                <>
                  <Box
                    sx={{
                      // width: 300,
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      paddingTop: 1,
                    }}
                  >
                    <TextField
                      select
                      variant="outlined"
                      label="Parameter Name"
                      name="parameter_id"
                      fullWidth
                      disabled
                      value={addTargetData?.parameter_id}
                      onChange={onChange}
                      error={!!errors?.parameter_id}
                      helperText={errors?.parameter_id}
                      size="small"
                      required
                      InputLabelProps={{
                        style: {
                          fontSize: "14px",
                          backgroundColor: "#fff",
                          padding: "0 4px",
                        },
                      }}
                    >
                      <MenuItem value="">
                        <>Unit of Measurement</>
                      </MenuItem>
                      {parameter?.parameter_names?.map((item) => (
                        <MenuItem value={item.parameter_id}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </TextField>
                    <Box display={"flex"} gap={1} sx={{ py: 1 }}>
                      <TextField
                        label="Valid Form"
                        variant="outlined"
                        name="validFrom"
                        fullWidth
                        type="date"
                        size="small"
                        value={addTargetData?.validFrom}
                        onChange={onChange}
                        InputLabelProps={{ shrink: true }}
                        error={!!errors?.validFrom}
                        helperText={errors?.validFrom}
                        required
                      />
                      <TextField
                        label="Valid Through"
                        variant="outlined"
                        name="validThrough"
                        fullWidth
                        type="date"
                        size="small"
                        value={addTargetData?.validThrough}
                        onChange={onChange}
                        InputLabelProps={{ shrink: true }}
                        error={!!errors?.validThrough}
                        helperText={errors?.validThrough}
                      />
                    </Box>
                    <TextField
                      label="Process Target"
                      name="processTarget"
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={addTargetData?.processTarget}
                      onChange={onChange}
                      error={!!errors?.processTarget}
                      helperText={errors?.processTarget}
                    />

                    <TextField
                      fullWidth
                      label="Change Reason"
                      name="changeReason"
                      variant="outlined"
                      size="small"
                      value={addTargetData?.changeReason}
                      onChange={onChange}
                      error={!!errors?.changeReason}
                      helperText={errors?.changeReason}
                      required
                    />
                  </Box>
                </>
              )}
            </DialogContent>
            <DialogActions
              sx={{
                justifyContent: "flex-start",
                p: 1,
                borderTop: "1px solid #ccc",
                paddingLeft: 0,
              }}
            >
              <Buttons
                size="small"
                text="Submit"
                onClick={(e) => handleSubmit(e, isAdd)}
                loading={limitOperation?.loader}
              />
              <Buttons
                size="small"
                text="Save Draft"
                onClick={handleSaveAsDraft}
                loading={limitOperation?.draftLoader}
              />
              <Buttons
                size="small"
                colors="gray"
                text="Cancel"
                onClick={() => setIsEdit(false)}
              />
            </DialogActions>
          </>
        </>
      ) : (
        <>
          <DialogTitle className="dialog-title">
            <Label text="Definition" color="#fff" fontSize="14px"></Label>

            <IconButton onClick={onClose} sx={{ color: "white" }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ padding: 0.1 }}>
            <Table
              size="small"
              sx={{
                "& .MuiTableCell-root": {
                  borderBottom: "none",
                },
                mt: 2,
              }}
            >
              <TableBody className="limit-defination-box">
                <TableRow>
                  <TableCell sx={{ fontWeight: "600", width: "40%" }}>
                    Parameter Name
                  </TableCell>
                  <TableCell>{viewPrimaryData?.label + (viewPrimaryData?.unit_of_measure ? (` (${viewPrimaryData?.unit_of_measure})`) : "")}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "600" }}>
                    Parameter Class
                  </TableCell>
                  <TableCell>
                    {viewPrimaryData?.parameter_class}
                  </TableCell>
                </TableRow>
                {/* <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Parameter ID
                  </TableCell>
                  <TableCell>{viewData?.parameter_id}</TableCell>
                </TableRow> */}
                <TableRow>
                  <TableCell sx={{ fontWeight: "600" }}>Valid From</TableCell>
                  <TableCell>
                    {moment(viewData?.valid_from).isValid()
                      ? moment(viewData?.valid_from).format("DD-MMM-YYYY")
                      : "-"}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "600" }}>
                    Valid Through
                  </TableCell>
                  <TableCell>
                    {moment(viewData?.valid_through).isValid()
                      ? moment(viewData?.valid_through).format("DD-MMM-YYYY")
                      : "-"}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "600" }}>Box-Cox λ</TableCell>
                  <TableCell>{viewData?.boxcoxlambdavalue}</TableCell>
                </TableRow>
                {viewData?.spec_limit_id && (
                  <TableRow>
                    <TableCell sx={{ fontWeight: "600" }}>
                      Process target
                    </TableCell>
                    <TableCell>{viewData?.process_target}</TableCell>
                  </TableRow>
                )}
                <TableRow>
                  <TableCell sx={{ fontWeight: "600" }}>
                    {viewData?.spec_limit_id ? "Limit Ranges" : "Values"}
                  </TableCell>
                  <TableCell>
                    {viewData?.spec_limit_id ? (
                      <>
                        {" "}
                        {viewData?.spec_name && `${viewData?.spec_name} `}
                        {
                          viewData?.lower_limit_type != null &&
                            viewData?.lower_spec != null &&
                            viewData?.upper_limit_type != null &&
                            viewData?.upper_spec != null
                            ? // both present
                            `${viewData.lower_limit_type} ${viewData.lower_spec} And ${viewData.upper_limit_type} ${viewData.upper_spec}`
                            : viewData?.lower_limit_type != null &&
                              viewData?.lower_spec != null
                              ? // only lower
                              `${viewData.lower_limit_type} ${viewData.lower_spec}`
                              : viewData?.upper_limit_type != null &&
                                viewData?.upper_spec != null
                                ? // only upper
                                `${viewData.upper_limit_type} ${viewData.upper_spec}`
                                : "" // none
                        } {" "}
                        {/* {viewData?.process_target && (
                          <span
                            style={{
                              backgroundColor: "#C9F6CF",
                              padding: "5px",
                            }}
                          >
                          Process Target: {viewData.process_target}
                          </span>
                        )} */}
                      </>
                    ) : (
                      <>
                        {" "}
                        <div>  {formatValues(
                          viewData?.lt_std_dev,
                          viewData?.st_std_dev,
                          "Lt Std Dev",
                          "St Std Dev",
                          "Std Dev"
                        )}{" "}</div>
                        <div>
                          {formatValues(
                            viewData?.lower_control,
                            viewData?.upper_control,
                            "Lower CL",
                            "Upper CL",
                            "CL"
                          )}{" "}
                        </div>
                        <div>
                          {formatValues(
                            viewData?.lower_warning,
                            viewData?.upper_warning,
                            "Lower WL",
                            "Upper WL",
                            "WL"
                          )}{' '}</div>
                        <div> {formatValues(
                          viewData?.lil,
                          viewData?.uil,
                          "LIL",
                          "UIL",
                          "IL"
                        )}</div>
                        <div> {formatValues(
                          viewData?.cp,
                          viewData?.cpl,
                          "Cp",
                          "Cpl",
                          "Cp/Cpl"
                        )}</div>
                        <div> {formatValues(
                          viewData?.cpu,
                          viewData?.cpk,
                          "Cpu",
                          "Cpk",
                          "Cpu/Cpk"
                        )}</div>
                        <div> {formatValues(
                          viewData?.pp,
                          viewData?.ppl,
                          "Pp",
                          "Ppl",
                          "Pp/Ppl"
                        )}</div>
                        <div> {formatValues(
                          viewData?.ppu,
                          viewData?.ppk,
                          "Ppu",
                          "Ppk",
                          "Ppu/Ppk"
                        )}</div>
                        {viewData?.target_mean !== null &&
                          `Mean: ${viewData?.target_mean}`}
                      </>
                    )}
                    {/* {viewData?.spec_name}{" "}
                    {viewData?.lower_control || viewData?.lower_spec
                      ? viewData?.upper_control || viewData?.upper_spec
                        ? // both present
                          `${viewData?.lowerlimittype || ">= "} ${viewData?.lower_control || viewData?.lower_spec} And ${viewData?.upperlimittype || "<="} ${viewData?.upper_control || viewData?.upper_spec}`
                        : // only lower
                          `${viewData?.lowerlimittype || ">= "} ${viewData?.lower_control || viewData?.lower_spec}`
                      : viewData?.upper_control || viewData?.upper_spec
                        ? // only upper
                          `${viewData?.upperlimittype || "<="} ${viewData?.upper_control || viewData?.upper_spec}`
                        : ""} */}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "600" }}>
                    Acceptable Values
                  </TableCell>
                  <TableCell>{(viewData?.acceptable_value)?.replace(/[{}"]/g, '')}</TableCell>
                </TableRow>
                {viewData?.spec_limit_id && (
                  <TableRow>
                    <TableCell sx={{ fontWeight: "600" }}>
                      Acceptance Criteria
                    </TableCell>
                    <TableCell>{viewData?.acceptance_criteria}</TableCell>
                  </TableRow>
                )}
                {viewData?.spec_limit_id && (
                  <TableRow>
                    <TableCell sx={{ fontWeight: "600" }}>Method</TableCell>
                    <TableCell>{viewData?.method}</TableCell>
                  </TableRow>
                )}
                <TableRow>
                  <TableCell sx={{ fontWeight: "600" }}>
                    Reference URLs
                  </TableCell>
                  <TableCell>{viewData?.reference_urls}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "600" }}>Attachments</TableCell>
                  <TableCell>{viewData?.attachments}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "600" }}>Comments</TableCell>
                  <TableCell>{viewData?.comment}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "600" }}>
                    Change Reason
                  </TableCell>
                  <TableCell>{viewData?.change_reason}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "600" }}>Status</TableCell>
                  <TableCell>{viewData?.status}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "600" }}>
                    Last Saved By
                  </TableCell>
                  <TableCell>{viewData?.last_saved_by}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "600" }}>
                    Last Saved On
                  </TableCell>
                  <TableCell>
                    {moment(viewData?.last_saved_on).isValid()
                      ? moment(viewData?.last_saved_on).format("DD-MMM-YYYY")
                      : "-"}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "600" }}>
                    Last Submitted By
                  </TableCell>
                  <TableCell>{viewData?.updated_by}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: "600" }}>
                    Last Submitted On
                  </TableCell>
                  <TableCell>
                    {moment(viewData?.created_at).isValid()
                      ? moment(viewData?.created_at).format("DD-MMM-YYYY")
                      : "-"}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: 1,
              borderTop: "1px solid #ccc",
              paddingLeft: 0,
            }}
          >
            {/* <Buttons
              colors="gray"
              size="small"
              text="Add Limit"
              onClick={() => {
                setIsEdit(true);
                setIsAdd(true);
              }}
            /> */}
            <Buttons
              colors="gray"
              size="small"
              text="Edit"
              onClick={() => {
                setIsEdit(true);
                setIsAdd(false);
              }}
            // disabled
            />
            <Buttons
              colors="orange"
              size="small"
              text="Delete"
              // disabled
              onClick={handleDelete}
            />
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default DefinitionPopup;
